import { render } from "./App.vue?vue&type=template&id=62582b90"
const script = {}

import exportComponent from "D:\\web\\dinner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__